__turbopack_context__.v({
  "label": "j_gYqq_label",
  "mui-status": "j_gYqq_mui-status",
  "mui-status--Accepted": "j_gYqq_mui-status--Accepted",
  "mui-status--Active": "j_gYqq_mui-status--Active",
  "mui-status--Awaiting-Signers": "j_gYqq_mui-status--Awaiting-Signers",
  "mui-status--Budget": "j_gYqq_mui-status--Budget",
  "mui-status--Called": "j_gYqq_mui-status--Called",
  "mui-status--Canceled": "j_gYqq_mui-status--Canceled",
  "mui-status--Complete": "j_gYqq_mui-status--Complete",
  "mui-status--Completed": "j_gYqq_mui-status--Completed",
  "mui-status--Countersign-Ready": "j_gYqq_mui-status--Countersign-Ready",
  "mui-status--Created": "j_gYqq_mui-status--Created",
  "mui-status--Deleted": "j_gYqq_mui-status--Deleted",
  "mui-status--Delivered": "j_gYqq_mui-status--Delivered",
  "mui-status--Delivering": "j_gYqq_mui-status--Delivering",
  "mui-status--Disputed": "j_gYqq_mui-status--Disputed",
  "mui-status--Draft": "j_gYqq_mui-status--Draft",
  "mui-status--Duplicate": "j_gYqq_mui-status--Duplicate",
  "mui-status--FullyPaidPartiallyRefunded": "j_gYqq_mui-status--FullyPaidPartiallyRefunded",
  "mui-status--Needs-Follow-Up": "j_gYqq_mui-status--Needs-Follow-Up",
  "mui-status--New": "j_gYqq_mui-status--New",
  "mui-status--Not-Available": "j_gYqq_mui-status--Not-Available",
  "mui-status--Other": "j_gYqq_mui-status--Other",
  "mui-status--Outstanding": "j_gYqq_mui-status--Outstanding",
  "mui-status--Overdue": "j_gYqq_mui-status--Overdue",
  "mui-status--Paid": "j_gYqq_mui-status--Paid",
  "mui-status--Partial-Refund": "j_gYqq_mui-status--Partial-Refund",
  "mui-status--Partial-Refunded": "j_gYqq_mui-status--Partial-Refunded",
  "mui-status--Partially-Paid": "j_gYqq_mui-status--Partially-Paid",
  "mui-status--PartiallySigned": "j_gYqq_mui-status--PartiallySigned",
  "mui-status--Pending": "j_gYqq_mui-status--Pending",
  "mui-status--ReadyToBeSignedByVendor": "j_gYqq_mui-status--ReadyToBeSignedByVendor",
  "mui-status--Refunded": "j_gYqq_mui-status--Refunded",
  "mui-status--Refunding": "j_gYqq_mui-status--Refunding",
  "mui-status--Retries-exhausted": "j_gYqq_mui-status--Retries-exhausted",
  "mui-status--Retrying": "j_gYqq_mui-status--Retrying",
  "mui-status--Scheduled": "j_gYqq_mui-status--Scheduled",
  "mui-status--Sent": "j_gYqq_mui-status--Sent",
  "mui-status--Sent-Message": "j_gYqq_mui-status--Sent-Message",
  "mui-status--Signed": "j_gYqq_mui-status--Signed",
  "mui-status--Spam": "j_gYqq_mui-status--Spam",
  "mui-status--Unpaid": "j_gYqq_mui-status--Unpaid",
  "mui-status--Unresponsive": "j_gYqq_mui-status--Unresponsive",
  "mui-status--Upcoming": "j_gYqq_mui-status--Upcoming",
  "mui-status--Viewed": "j_gYqq_mui-status--Viewed",
  "mui-status--Void": "j_gYqq_mui-status--Void",
});
